export default "__VITE_ASSET__19d692d0__"